// // components/Books.jsx
// import axios from "axios";
// import React, { useEffect, useState } from "react";

// const Books = () => {
//   const [isAdding, setIsAdding] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [editingBook, setEditingBook] = useState(null);
//   const [formData, setFormData] = useState({
//     title: "",
//     title_ar: "",
//     category_id: "",
//     image: null,
//   });
//   const [imagePreview, setImagePreview] = useState(null);
//   const [flag, setFlag] = useState(false);
//   const [image, setImage] = useState(null);
//   // Sample categories data - in real app, this would come from props or API
//   const [categories, setCategories] = useState([
//     { id: 1, title: "Science & Technology" },
//     { id: 2, title: "Literature & Fiction" },
//     { id: 3, title: "History & Biography" },
//     { id: 4, title: "Business & Economics" },
//     { id: 5, title: "Art & Photography" },
//   ]);

//   const [books, setBooks] = useState([
//     {
//       id: 1,
//       title: "The Science of Everything",
//       category_id: 1,
//       image: "/api/placeholder/300/400",
//       createdAt: "2024-01-15",
//     },
//     {
//       id: 2,
//       title: "Modern Business Strategies",
//       category_id: 4,
//       image: "/api/placeholder/300/400",
//       createdAt: "2024-01-10",
//     },
//     {
//       id: 3,
//       title: "Art Through the Ages",
//       category_id: 5,
//       image: "/api/placeholder/300/400",
//       createdAt: "2024-01-05",
//     },
//   ]);

//   // Handle Add/Edit Form Submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (isEditing && editingBook) {
//       const formDataRequest = new FormData();
//       formDataRequest.append("book_id", editingBook.id);
//       formDataRequest.append("title", formData.title);
//       formDataRequest.append("title_ar", formData.title_ar);
//       formDataRequest.append("category_id", formData.category_id);
//       if (image) {
//         formDataRequest.append("image", image);
//       }
//       await axios.patch(
//         process.env.REACT_APP_BASE_URL + "book/update-book",
//         formDataRequest
//       );
//       setFlag(!flag);
//     } else {
//       const formDataRequest = new FormData();
//       formDataRequest.append("title", formData.title);
//       formDataRequest.append("title_ar", formData.title_ar);
//       formDataRequest.append("category_id", formData.category_id);
//       formDataRequest.append("image", formData.image);
//       await axios.post(
//         process.env.REACT_APP_BASE_URL + "book/add-book",
//         formDataRequest
//       );
//       setFlag(!flag);
//     }

//     resetForm();
//   };

//   // Handle Edit
//   const handleEdit = (book) => {
//     setFormData({
//       title: book.title,
//       title_ar: book.title_ar,
//       category_id: book.category_id.toString(),
//       image: null,
//     });
//     setImagePreview(book.image);
//     setEditingBook(book);
//     setIsEditing(true);
//     setIsAdding(true);
//   };

//   // Handle Delete
//   const handleDelete = async (bookId) => {
//     // setBooks(books.filter((b) => b.id !== bookId));
//     await axios.delete(process.env.REACT_APP_BASE_URL + "book/delete-book", {
//       params: {
//         book_id: bookId,
//       },
//     });
//     setFlag(!flag);
//   };

//   // Reset form and states
//   const resetForm = () => {
//     setFormData({ title: "", category_id: "", image: null });
//     setImagePreview(null);
//     setIsAdding(false);
//     setIsEditing(false);
//     setEditingBook(null);
//   };

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value, files } = e.target;

//     if (name === "image" && files.length > 0) {
//       const file = files[0];
//       if (isEditing) {
//         setImage(file);
//       } else {
//         setFormData({
//           ...formData,
//           image: file,
//         });
//       }

//       // Create preview
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         setImagePreview(e.target.result);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }
//   };

//   // Get category title by ID
//   const getCategoryTitle = (categoryId) => {
//     const category = categories.find((cat) => cat.id === categoryId);
//     return category ? category.title : "Unknown Category";
//   };

//   // Format date
//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   useEffect(() => {
//     axios
//       .get(process.env.REACT_APP_BASE_URL + "book/get-all-books")
//       .then((res) => setBooks(res.data.data));
//   }, [flag]);

//   useEffect(() => {
//     axios
//       .get(
//         process.env.REACT_APP_BASE_URL +
//           "library-category/get-all-library-category"
//       )
//       .then((res) => setCategories(res.data.data));
//   }, []);

//   return (
//     <div className="space-y-8">
//       {/* Stats Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-gray-600 text-sm">Total Books</p>
//               <p className="text-3xl font-bold text-gray-800 mt-2">
//                 {books.length}
//               </p>
//             </div>
//             <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//               <span className="text-green-600 text-xl">📚</span>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-gray-600 text-sm">Categories</p>
//               <p className="text-3xl font-bold text-gray-800 mt-2">
//                 {categories.length}
//               </p>
//             </div>
//             <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//               <span className="text-green-600 text-xl">📑</span>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-gray-600 text-sm">New This Month</p>
//               <p className="text-3xl font-bold text-gray-800 mt-2">
//                 {
//                   books.filter((book) => {
//                     const bookDate = new Date(book.createdAt);
//                     const currentMonth = new Date().getMonth();
//                     const currentYear = new Date().getFullYear();
//                     return (
//                       bookDate.getMonth() === currentMonth &&
//                       bookDate.getFullYear() === currentYear
//                     );
//                   }).length
//                 }
//               </p>
//             </div>
//             <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//               <span className="text-green-600 text-xl">🆕</span>
//             </div>
//           </div>
//         </div>

//         {/* <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
//           <div className="flex items-center justify-between">
//             <div>
//               <p className="text-gray-600 text-sm">Most Popular</p>
//               <p className="text-lg font-bold text-gray-800 mt-2 truncate">
//                 {books[0]?.title || "No books"}
//               </p>
//             </div>
//             <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
//               <span className="text-green-600 text-xl">⭐</span>
//             </div>
//           </div>
//         </div> */}
//       </div>

//       {/* Header with Add Button */}
//       <div className="flex justify-between items-center">
//         <div>
//           <h2 className="text-2xl font-bold text-gray-800">Books Collection</h2>
//           <p className="text-gray-600 mt-1">
//             Manage your library books and collections
//           </p>
//         </div>
//         <button
//           onClick={() => setIsAdding(true)}
//           className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2 group"
//         >
//           <span className="group-hover:scale-110 transition-transform duration-200">
//             +
//           </span>
//           <span>Add Book</span>
//         </button>
//       </div>

//       {/* Add/Edit Book Form Modal */}
//       {isAdding && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl transform animate-scale-in max-h-[90vh] overflow-y-auto">
//             <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
//               <h3 className="text-xl font-bold text-gray-800">
//                 {isEditing ? "Edit Book" : "Add New Book"}
//               </h3>
//               <p className="text-green-600 text-sm mt-1">
//                 {isEditing
//                   ? "Update the book details"
//                   : "Add a new book to your library"}
//               </p>
//             </div>
//             <form onSubmit={handleSubmit} className="p-6 space-y-6">
//               {/* Image Upload */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Book Cover Image
//                 </label>
//                 <div className="flex items-center space-x-6">
//                   <div className="w-32 h-40 bg-green-100 rounded-lg border-2 border-dashed border-green-300 flex items-center justify-center overflow-hidden">
//                     {imagePreview ? (
//                       <img
//                         src={imagePreview}
//                         alt="Preview"
//                         className="w-full h-full object-cover"
//                       />
//                     ) : (
//                       <span className="text-green-400 text-2xl">📚</span>
//                     )}
//                   </div>
//                   <div className="flex-1">
//                     <input
//                       type="file"
//                       name="image"
//                       accept="image/*"
//                       onChange={handleChange}
//                       className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
//                     />
//                     <p className="text-sm text-gray-500 mt-2">
//                       Upload a book cover image (JPEG, PNG, WebP)
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Title Input */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Book Title *
//                 </label>
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
//                   placeholder="Enter book title"
//                 />
//               </div>

//                {/* Title Arabic Input */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Book Title Arabic *
//                 </label>
//                 <input
//                   type="text"
//                   name="title_ar"
//                   value={formData.title_ar}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
//                   placeholder="Enter book title"
//                 />
//               </div>

//               {/* Category Selection */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Category *
//                 </label>
//                 <select
//                   name="category_id"
//                   value={formData.category_id}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
//                 >
//                   <option value="">Select a category</option>
//                   {categories.map((category) => (
//                     <option key={category.id} value={category.id}>
//                       {category.title}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex space-x-3 pt-4">
//                 <button
//                   type="submit"
//                   className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
//                 >
//                   {isEditing ? "Update Book" : "Add Book"}
//                 </button>
//                 <button
//                   type="button"
//                   onClick={resetForm}
//                   className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Books Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
//         {books.map((book, index) => (
//           <div
//             key={book.id}
//             className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
//             style={{ animationDelay: `${index * 100}ms` }}
//           >
//             {/* Book Cover */}
//             <div className="h-48 bg-gradient-to-br from-green-100 to-green-200 relative overflow-hidden">
//               <div className="w-full h-full flex items-center justify-center">
//                 <span className="text-6xl text-green-600">📚</span>
//               </div>
//               <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1">
//                 <button
//                   onClick={() => handleEdit(book)}
//                   className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors duration-200 transform hover:scale-110 shadow-sm"
//                   title="Edit Book"
//                 >
//                   <svg
//                     className="w-3 h-3"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                     />
//                   </svg>
//                 </button>
//                 <button
//                   onClick={() => handleDelete(book.id)}
//                   className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors duration-200 transform hover:scale-110 shadow-sm"
//                   title="Delete Book"
//                 >
//                   <svg
//                     className="w-3 h-3"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
//                     />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {/* Book Details */}
//             <div className="p-4">
//               <h3 className="font-semibold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200 line-clamp-2">
//                 {book.title}
//               </h3>

//               <div className="space-y-2 text-sm text-gray-600">
//                 <div className="flex items-center space-x-2">
//                   <span className="w-2 h-2 bg-green-500 rounded-full"></span>
//                   <span>{getCategoryTitle(book.category_id)}</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
//                   <span>Added {formatDate(book.createdAt)}</span>
//                 </div>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex space-x-2 mt-4">
//                 <button className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 text-sm">
//                   View Details
//                 </button>
//                 <button className="flex-1 bg-blue-50 text-blue-600 py-2 px-3 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200 text-sm">
//                   Download
//                 </button>
//               </div>
//             </div>
//           </div>
//         ))}

//         {/* Add New Book Card */}
//         <div
//           className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group min-h-[300px] flex-column items-center justify-center"
//           onClick={() => setIsAdding(true)}
//         >
//           <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
//             <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
//               +
//             </span>
//           </div>
//           <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
//             Add New Book
//           </h3>
//           <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
//             Add a new book to your library collection
//           </p>
//         </div>
//       </div>

//       {/* Empty State */}
//       {books.length === 0 && (
//         <div className="text-center py-16">
//           <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
//             <span className="text-4xl text-green-600">📚</span>
//           </div>
//           <h3 className="text-xl font-semibold text-gray-700 mb-2">
//             No books in your library yet
//           </h3>
//           <p className="text-gray-500 mb-6 max-w-md mx-auto">
//             Start building your digital library by adding your first book.
//             Organize them by categories for easy access.
//           </p>
//           <button
//             onClick={() => setIsAdding(true)}
//             className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
//           >
//             Add First Book
//           </button>
//         </div>
//       )}

//       {/* Quick Stats Footer */}
//       {books.length > 0 && (
//         <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
//             <div>
//               <p className="text-sm opacity-90">Total Books</p>
//               <p className="text-2xl font-bold">{books.length}</p>
//             </div>
//             <div>
//               <p className="text-sm opacity-90">Categories Used</p>
//               <p className="text-2xl font-bold">
//                 {new Set(books.map((book) => book.category_id)).size}
//               </p>
//             </div>
//             <div>
//               <p className="text-sm opacity-90">Latest Addition</p>
//               <p className="text-lg font-bold truncate">
//                 {
//                   books.reduce(
//                     (latest, book) =>
//                       new Date(book.createdAt) > new Date(latest.createdAt)
//                         ? book
//                         : latest,
//                     books[0]
//                   )?.title
//                 }
//               </p>
//             </div>
//             <div>
//               <p className="text-sm opacity-90">Most Common Category</p>
//               <p className="text-lg font-bold truncate">
//                 {(() => {
//                   const categoryCounts = {};
//                   books.forEach((book) => {
//                     categoryCounts[book.category_id] =
//                       (categoryCounts[book.category_id] || 0) + 1;
//                   });
//                   const mostCommonId = Object.keys(categoryCounts).reduce(
//                     (a, b) => (categoryCounts[a] > categoryCounts[b] ? a : b)
//                   );
//                   return getCategoryTitle(parseInt(mostCommonId));
//                 })()}
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Books;


// components/Books.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";

const Books = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingBook, setEditingBook] = useState(null);
  const [loading, setLoading] = useState(false); // Add/edit button loading state
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const [formData, setFormData] = useState({
    title: "",
    title_ar: "",
    category_id: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [flag, setFlag] = useState(false);
  const [image, setImage] = useState(null);
  // Sample categories data - in real app, this would come from props or API
  const [categories, setCategories] = useState([
    { id: 1, title: "Science & Technology" },
    { id: 2, title: "Literature & Fiction" },
    { id: 3, title: "History & Biography" },
    { id: 4, title: "Business & Economics" },
    { id: 5, title: "Art & Photography" },
  ]);

  const [books, setBooks] = useState([
    {
      id: 1,
      title: "The Science of Everything",
      category_id: 1,
      image: "/api/placeholder/300/400",
      createdAt: "2024-01-15",
    },
    {
      id: 2,
      title: "Modern Business Strategies",
      category_id: 4,
      image: "/api/placeholder/300/400",
      createdAt: "2024-01-10",
    },
    {
      id: 3,
      title: "Art Through the Ages",
      category_id: 5,
      image: "/api/placeholder/300/400",
      createdAt: "2024-01-05",
    },
  ]);

  // Filter books based on search query
  const filteredBooks = books.filter(book =>
    book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (book.title_ar && book.title_ar.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  // Handle Add/Edit Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    try {
      if (isEditing && editingBook) {
        const formDataRequest = new FormData();
        formDataRequest.append("book_id", editingBook.id);
        formDataRequest.append("title", formData.title);
        formDataRequest.append("title_ar", formData.title_ar);
        formDataRequest.append("category_id", formData.category_id);
        if (image) {
          formDataRequest.append("image", image);
        }
        await axios.patch(
          process.env.REACT_APP_BASE_URL + "book/update-book",
          formDataRequest
        );
        setFlag(!flag);
      } else {
        const formDataRequest = new FormData();
        formDataRequest.append("title", formData.title);
        formDataRequest.append("title_ar", formData.title_ar);
        formDataRequest.append("category_id", formData.category_id);
        formDataRequest.append("image", formData.image);
        await axios.post(
          process.env.REACT_APP_BASE_URL + "book/add-book",
          formDataRequest
        );
        setFlag(!flag);
      }
      resetForm();
    } catch (error) {
      console.error("Error saving book:", error);
      // You might want to show an error message here
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Handle Edit
  const handleEdit = (book) => {
    setFormData({
      title: book.title,
      title_ar: book.title_ar,
      category_id: book.category_id.toString(),
      image: null,
    });
    setImagePreview(book.image);
    setEditingBook(book);
    setIsEditing(true);
    setIsAdding(true);
  };

  // Handle Delete
  const handleDelete = async (bookId) => {
    // Show confirmation dialog before deleting
    if (window.confirm("Are you sure you want to delete this book?")) {
      try {
        await axios.delete(process.env.REACT_APP_BASE_URL + "book/delete-book", {
          params: {
            book_id: bookId,
          },
        });
        setFlag(!flag);
      } catch (error) {
        console.error("Error deleting book:", error);
      }
    }
  };

  // Reset form and states
  const resetForm = () => {
    setFormData({ title: "", category_id: "", image: null, title_ar: "" });
    setImagePreview(null);
    setIsAdding(false);
    setIsEditing(false);
    setEditingBook(null);
    setLoading(false);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files.length > 0) {
      const file = files[0];
      if (isEditing) {
        setImage(file);
      } else {
        setFormData({
          ...formData,
          image: file,
        });
      }

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Get category title by ID
  const getCategoryTitle = (categoryId) => {
    const category = categories.find((cat) => cat.id === categoryId);
    return category ? category.title : "Unknown Category";
  };

  // Format date
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BASE_URL + "book/get-all-books")
      .then((res) => setBooks(res.data.data));
  }, [flag]);

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "library-category/get-all-library-category"
      )
      .then((res) => setCategories(res.data.data));
  }, []);

  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Books</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {books.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📚</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Categories</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {categories.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📑</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">New This Month</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {
                  books.filter((book) => {
                    const bookDate = new Date(book.createdAt);
                    const currentMonth = new Date().getMonth();
                    const currentYear = new Date().getFullYear();
                    return (
                      bookDate.getMonth() === currentMonth &&
                      bookDate.getFullYear() === currentYear
                    );
                  }).length
                }
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">🆕</span>
            </div>
          </div>
        </div>
      </div>

      {/* Header with Add Button and Search */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Books Collection</h2>
          <p className="text-gray-600 mt-1">
            Manage your library books and collections
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
          {/* Search Bar */}
          <div className="relative flex-1 sm:w-64">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search books by name..."
              className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>

          {/* Add Book Button */}
          <button
            onClick={() => setIsAdding(true)}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-2.5 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center space-x-2 group min-w-[140px]"
          >
            <span className="group-hover:scale-110 transition-transform duration-200">
              +
            </span>
            <span>Add Book</span>
          </button>
        </div>
      </div>

      {/* Search Results Info */}
      {searchQuery && (
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-blue-700 flex items-center">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Showing {filteredBooks.length} result{filteredBooks.length !== 1 ? 's' : ''} for "{searchQuery}"
            {filteredBooks.length === 0 && books.length > 0 && (
              <button
                onClick={() => setSearchQuery("")}
                className="ml-2 text-green-600 hover:text-green-800 font-medium"
              >
                Clear search
              </button>
            )}
          </p>
        </div>
      )}

      {/* Add/Edit Book Form Modal */}
      {isAdding && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl transform animate-scale-in max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                {isEditing ? "Edit Book" : "Add New Book"}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                {isEditing
                  ? "Update the book details"
                  : "Add a new book to your library"}
              </p>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              {/* Image Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Book Cover Image
                </label>
                <div className="flex items-center space-x-6">
                  <div className="w-32 h-40 bg-green-100 rounded-lg border-2 border-dashed border-green-300 flex items-center justify-center overflow-hidden">
                    {imagePreview ? (
                      <img
                        src={imagePreview}
                        alt="Preview"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <span className="text-green-400 text-2xl">📚</span>
                    )}
                  </div>
                  <div className="flex-1">
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      Upload a book cover image (JPEG, PNG, WebP)
                    </p>
                  </div>
                </div>
              </div>

              {/* Title Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Book Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter book title"
                />
              </div>

              {/* Title Arabic Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Book Title Arabic *
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={formData.title_ar}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter book title in Arabic"
                />
              </div>

              {/* Category Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category *
                </label>
                <select
                  name="category_id"
                  value={formData.category_id}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                >
                  <option value="">Select a category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.title}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center"
                >
                  {loading ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {isEditing ? "Updating..." : "Adding..."}
                    </>
                  ) : (
                    <>{isEditing ? "Update Book" : "Add Book"}</>
                  )}
                </button>
                <button
                  type="button"
                  onClick={resetForm}
                  disabled={loading}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Books Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredBooks.map((book, index) => (
          <div
            key={book.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 transition-all duration-300 group animate-fade-in border border-green-100"
            style={{ animationDelay: `${index * 100}ms` }}
          >
            {/* Book Cover */}
            <div className="h-48 bg-gradient-to-br from-green-100 to-green-200 relative overflow-hidden">
              <div className="w-full h-full flex items-center justify-center">
                <span className="text-6xl text-green-600">📚</span>
              </div>
              <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1">
                <button
                  onClick={() => handleEdit(book)}
                  className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center hover:bg-green-600 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Edit Book"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </button>
                <button
                  onClick={() => handleDelete(book.id)}
                  className="w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors duration-200 transform hover:scale-110 shadow-sm"
                  title="Delete Book"
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Book Details */}
            <div className="p-4">
              <h3 className="font-semibold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200 line-clamp-2">
                {book.title}
              </h3>
              {book.title_ar && (
                <p className="text-sm text-gray-600 mb-2 text-right" dir="rtl">
                  {book.title_ar}
                </p>
              )}

              <div className="space-y-2 text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  <span>{getCategoryTitle(book.category_id)}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                  <span>Added {formatDate(book.createdAt)}</span>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-2 mt-4">
                <button className="flex-1 bg-green-50 text-green-600 py-2 px-3 rounded-lg font-medium hover:bg-green-100 transition-colors duration-200 text-sm">
                  View Details
                </button>
                <button className="flex-1 bg-blue-50 text-blue-600 py-2 px-3 rounded-lg font-medium hover:bg-blue-100 transition-colors duration-200 text-sm">
                  Download
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* Add New Book Card (only shown when not searching or no results) */}
        {!searchQuery && (
          <div
            className="border-2 border-dashed border-green-300 rounded-2xl p-8 text-center hover:border-green-500 hover:bg-green-50 transition-all duration-300 cursor-pointer group min-h-[300px] flex-column items-center justify-center"
            onClick={() => setIsAdding(true)}
          >
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-green-200 transition-colors duration-200">
              <span className="text-2xl text-green-600 group-hover:scale-110 transition-transform duration-200">
                +
              </span>
            </div>
            <h3 className="text-lg font-semibold text-gray-700 mb-2 group-hover:text-green-700 transition-colors duration-200">
              Add New Book
            </h3>
            <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors duration-200">
              Add a new book to your library collection
            </p>
          </div>
        )}

        {/* No Search Results */}
        {searchQuery && filteredBooks.length === 0 && (
          <div className="col-span-full text-center py-12">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl text-gray-400">🔍</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              No books found
            </h3>
            <p className="text-gray-500 mb-6 max-w-md mx-auto">
              No books match your search for "{searchQuery}". Try a different search term.
            </p>
            <button
              onClick={() => setSearchQuery("")}
              className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              View All Books
            </button>
          </div>
        )}
      </div>

      {/* Empty State (when no books at all) */}
      {books.length === 0 && !searchQuery && (
        <div className="text-center py-16">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-4xl text-green-600">📚</span>
          </div>
          <h3 className="text-xl font-semibold text-gray-700 mb-2">
            No books in your library yet
          </h3>
          <p className="text-gray-500 mb-6 max-w-md mx-auto">
            Start building your digital library by adding your first book.
            Organize them by categories for easy access.
          </p>
          <button
            onClick={() => setIsAdding(true)}
            className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Add First Book
          </button>
        </div>
      )}

      {/* Quick Stats Footer */}
      {books.length > 0 && !searchQuery && (
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div>
              <p className="text-sm opacity-90">Total Books</p>
              <p className="text-2xl font-bold">{books.length}</p>
            </div>
            <div>
              <p className="text-sm opacity-90">Categories Used</p>
              <p className="text-2xl font-bold">
                {new Set(books.map((book) => book.category_id)).size}
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Latest Addition</p>
              <p className="text-lg font-bold truncate">
                {
                  books.reduce(
                    (latest, book) =>
                      new Date(book.createdAt) > new Date(latest.createdAt)
                        ? book
                        : latest,
                    books[0]
                  )?.title
                }
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Most Common Category</p>
              <p className="text-lg font-bold truncate">
                {(() => {
                  const categoryCounts = {};
                  books.forEach((book) => {
                    categoryCounts[book.category_id] =
                      (categoryCounts[book.category_id] || 0) + 1;
                  });
                  const mostCommonId = Object.keys(categoryCounts).reduce(
                    (a, b) => (categoryCounts[a] > categoryCounts[b] ? a : b)
                  );
                  return getCategoryTitle(parseInt(mostCommonId));
                })()}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Books;